// 高阶路由组件

import { Navigate } from "react-router-dom";
import { getToken } from "../utils";

// 有token，正常跳转；无token，强制跳到登录页
export function AuthRouter({children}){
    const token=getToken();
    if(token){
        return <>{children}</>
    }else{
        return <Navigate to={'/login'} replace/>
    }
}
